import "./ContactUsLink.scss";

import { Button, Text } from "@fluentui/react-northstar";
import { UserDTO } from "@teams/types/api";
import React from "react";

import { useHubspotChat } from "../actions/useHubspotChat";
import { useTeamsContext } from "../state/TeamsContextProvider";
import { clientEventTracker } from "../utils/clientTelemetry";
import { PollyIcon } from "./PollyIcon";

interface Props {
  user: UserDTO;
  label?: string;
  useEmail?: boolean; // if true, intercom will not be used.  mailto will be used
  redirectToWebsite?: boolean;
}

export const ContactUsLink: React.FC<Props> = ({
  user,
  label = "Contact Support",
  useEmail = false,
  redirectToWebsite,
}) => {
  const { teamsContext } = useTeamsContext();
  const { loadHubspotChat } = useHubspotChat();

  if (useEmail) {
    return (
      <a
        className="contact-us-link"
        href={`mailto:contact@polly.ai?subject=Polly%20Teams%20Support&body=%0A%0A%0AUserId:%20${encodeURIComponent(
          user.userId
        )}%0ATenantID:%20${encodeURIComponent(user.tenantId)}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => {
          clientEventTracker.track("ContactSales clicked", user, {
            upn: user.upn,
            method: "email",
          });
        }}
      >
        <PollyIcon
          primary
          ignoreTheme={true}
          icon="announcement-icon"
          label={<Text weight="bold" content={label} />}
        />
      </a>
    );
  }

  return (
    <Button
      className="contact-us-link__button"
      data-tname="contact-us"
      text
      onClick={() => {
        clientEventTracker.track("ContactSales clicked", user, {
          upn: user.upn,
          method: redirectToWebsite ? "Payment Page" : "hubspot",
        });
        if (redirectToWebsite) {
          window.open("https://www.polly.ai/talk-to-sales", "_blank");
          return;
        }
        loadHubspotChat(teamsContext, true);
      }}
      content={
        <PollyIcon
          primary
          ignoreTheme={true}
          icon="announcement-icon"
          label={<Text weight="bold" content={label} />}
        />
      }
    />
  );
};
